import { DateFormatter } from '@repo/toolkit/date'

import { TransportTypeEnum, TripTypeEnum } from '../../types/enums/trip/trip-type.enum'
import { TripBookingTypes } from '../../types/models/trip-booking/trip-booking'

export const transformTripBookingFiltersToUrl = (filters?: TripBookingTypes.Filters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.lecResponsableIds)
    searchParams.set('lecResponsableIds', filters.lecResponsableIds.join(','))

  if (filters.tripTypes) searchParams.set('tripTypes', filters.tripTypes.join(','))

  if (filters.directionalities)
    searchParams.set('directionalities', filters.directionalities.join(','))

  if (filters.transportMeansIds)
    searchParams.set('transportMeansIds', filters.transportMeansIds.join(','))

  if (filters.tripProviderIds)
    searchParams.set('tripProviderIds', filters.tripProviderIds.join(','))

  if (filters.travelCompanyIds)
    searchParams.set('travelCompanyIds', filters.travelCompanyIds.join(','))

  if (filters.totalNumberOfPlaces)
    searchParams.set('totalNumberOfPlaces', filters.totalNumberOfPlaces.toString())

  if (filters.numberOfStaffPlacesReserved)
    searchParams.set('numberOfStaffPlacesReserved', filters.numberOfStaffPlacesReserved.toString())

  if (filters.departureDate) searchParams.set('departureDate', filters.departureDate)
  if (filters.arrivalDate) searchParams.set('arrivalDate', filters.arrivalDate)
  if (filters.departureCountry) searchParams.set('departureCountry', filters.departureCountry)
  if (filters.arrivalCountry) searchParams.set('arrivalCountry', filters.arrivalCountry)
  if (filters.departureCity) searchParams.set('departureCity', filters.departureCity)
  if (filters.arrivalCity) searchParams.set('arrivalCity', filters.arrivalCity)
  if (filters.isTakeInCharge) searchParams.set('isTakeInCharge', filters.isTakeInCharge.toString())

  return searchParams.toString()
}

export const transformUrlToTripBookingFilters = (
  searchParams: URLSearchParams
): TripBookingTypes.Filters => {
  const filters: TripBookingTypes.Filters = {}

  const lecResponsableIds = searchParams.get('lecResponsableIds')
  if (lecResponsableIds) filters.lecResponsableIds = lecResponsableIds.split(',').map(Number)

  const tripTypes = searchParams.get('tripTypes')
  if (tripTypes) filters.tripTypes = tripTypes.split(',') as TripTypeEnum[]

  const directionalities = searchParams.get('directionalities')
  if (directionalities)
    filters.directionalities = directionalities.split(',') as TransportTypeEnum[]

  const transportMeansIds = searchParams.get('transportMeansIds')
  if (transportMeansIds) filters.transportMeansIds = transportMeansIds.split(',').map(Number)

  const tripProviderIds = searchParams.get('tripProviderIds')
  if (tripProviderIds) filters.tripProviderIds = tripProviderIds.split(',').map(Number)

  const travelCompanyIds = searchParams.get('travelCompanyIds')
  if (travelCompanyIds) filters.travelCompanyIds = travelCompanyIds.split(',').map(Number)

  const departureDate = DateFormatter.checkDateFormat(searchParams.get('departureDate'))
  if (departureDate) filters.departureDate = departureDate

  const arrivalDate = DateFormatter.checkDateFormat(searchParams.get('arrivalDate'))
  if (arrivalDate) filters.arrivalDate = arrivalDate

  const departureCountry = searchParams.get('departureCountry')
  if (departureCountry) filters.departureCountry = departureCountry

  const arrivalCountry = searchParams.get('arrivalCountry')
  if (arrivalCountry) filters.arrivalCountry = arrivalCountry

  const departureCity = searchParams.get('departureCity')
  if (departureCity) filters.departureCity = departureCity

  const arrivalCity = searchParams.get('arrivalCity')
  if (arrivalCity) filters.arrivalCity = arrivalCity

  const totalNumberOfPlaces = searchParams.get('totalNumberOfPlaces')
  if (totalNumberOfPlaces) filters.totalNumberOfPlaces = Number(totalNumberOfPlaces)

  const numberOfStaffPlacesReserved = searchParams.get('numberOfStaffPlacesReserved')
  if (numberOfStaffPlacesReserved)
    filters.numberOfStaffPlacesReserved = Number(numberOfStaffPlacesReserved)

  const isTakeInCharge = searchParams.get('isTakeInCharge')
  if (isTakeInCharge) filters.isTakeInCharge = isTakeInCharge === 'true'

  return filters
}
